"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSE_BUTTON_DATA_TEST = exports.TOKENS = exports.TYPE_OPTIONS = void 0;
var TYPE_OPTIONS = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  CRITICAL: "critical"
};
exports.TYPE_OPTIONS = TYPE_OPTIONS;
var TOKENS = {
  backgroundAlert: "backgroundAlert",
  colorIconAlert: "colorIconAlert",
  colorTextAlert: "colorTextAlert",
  colorTextLinkAlertHover: "colorTextLinkAlertHover"
};
exports.TOKENS = TOKENS;
var CLOSE_BUTTON_DATA_TEST = "AlertCloseButton";
exports.CLOSE_BUTTON_DATA_TEST = CLOSE_BUTTON_DATA_TEST;